import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { hideModal } from '../../actions/modal'
import { deletePool, DELETE_POOL } from '../../actions/poolDelete'
import ModalComponent from '../../components/modal/index'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'

export class DeletePoolModal extends React.Component {

  constructor() {
    super()
    this.deletePool = this.deletePool.bind(this)
  }

  deletePool() {
    this.props.deletePool(this.props.poolId)
  }

  render() {
    if (this.props.isOpen && this.props.modalType === DELETE_POOL) {

      const body = <div>Are you sure you want to delete <mark>{this.props.poolName}</mark>?</div>

      const primaryButton = <Button color="danger" onClick={this.deletePool}>Delete</Button>

      return <ModalComponent
        isOpen={this.props.isOpen}
        body={body}
        toggle={this.props.hideModal}
        primaryButton={primaryButton} />
    }

    return null
  }
}

const mapStateToProps = state => {
  return {
    isOpen: state.modal.isOpen,
    modalType: state.modal.modalType,
    poolId: state.poolDetails.id,
    poolName: state.poolDetails.poolName
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  hideModal,
  deletePool
}, dispatch)

DeletePoolModal.propTypes = {
  isOpen: PropTypes.bool,
  poolName: PropTypes.string,
  modalType: PropTypes.string,
  poolId: PropTypes.string,
  hideModal: PropTypes.func,
  deletePool: PropTypes.func
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeletePoolModal)



// WEBPACK FOOTER //
// ./src/containers/modal/deletePool.js